import { Box, Image, Text } from "@chakra-ui/react";

export const PoweredBy = ({ currentChatPanelview }) => {
  return (
    <Box
      className="ui-poweredby-strip"
      display="flex"
      position={currentChatPanelview !== "conversation" ? "absolute" : "static"}
      bottom={0}
      width="100%"
      alignItems="center"
      justifyContent="center"
      padding="8px 0"
      backgroundColor="rgba(255, 255, 255, 0.9)" // Light background for visibility
    >
      <a
        href="https://www.ulai.in"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}
      >
        <Text fontSize="10px" fontWeight="500">Powered By</Text>
        <Image
          src="https://ulai.in/static/media/ULAILogoFooter.b05c2bd94261bef10b83da1077f4cfba.svg"
          alt="ULAI Logo"
          width="38px"
          height="15px"
          marginLeft="2px"
          marginBottom={"2px"}

        />
      </a>
    </Box>
  );
};
